import { useMemo } from 'react';
import ListView from './list-view';
import Accordion from '../accordion';
import { CATALYST } from '../../enum';
import { catalysts } from '../../data/catalysts';
import { bases } from '../../data/bases';

const ProductTitleName = ({ p }) => (
	<span>
		<img
			src={`./assets/items/${p.id}.gif`}
			alt={`${p.name}`}
			title={`${p.name}`}
		/>
		{p.name}
		{p?.element?.length > 0 && <i className={`ele-box ${p.element.toLowerCase()}`} />}
	</span>
);

const ByProductView = ({ basket, ingredients }) => {
	const productList = useMemo(() => {
		const items = [];
		return basket.map((b, bi) => {
			if (b && b?.catalyst !== CATALYST.NONE) {
				items.unshift(catalysts[b.catalyst]);
			}
			if (b && b?.base) {
				// Base is needed twice.
				items.unshift({ ...bases[b.base], productId: b.id });
				items.unshift({ ...bases[b.base], productId: b.id });
			}
			return { ...b, items: ingredients[bi].filter((item) => {
				return item !== null;
			})}
		});
	}, [basket, ingredients]);

	return (
		<>
			{productList.map((p, pi) => (
				<div key={pi}>
					<Accordion title={<ProductTitleName p={p} />}>
						<ListView
							items={[
								{ ...bases[p?.base], name: `2x ${bases[p?.base]?.name}`, productId: p.id },
								...p.items,
								p?.catalyst !== CATALYST.NONE ?
									{
										...catalysts[p.catalyst],
										isCatalyst: true,
									} :
									null,
								p?.agent?.id ?
									{
										...p.agent,
										name: `${p.agent?.name} [AGENT]`,
									} :
									null
							]}
							reduce={false}
							className={'is-by-product-view'}
							withDeliverySelect={true}
						/>
					</Accordion>
					{/* <h4>{p.name}</h4>
					<ListView items={p.items} reduce={false} className={'is-by-product-view'} /> */}
				</div>
			))}
		</>
	);
};

export default ByProductView;
